import { render, staticRenderFns } from "./FeatureSvg.vue?vue&type=template&id=18489e7e"
import script from "./FeatureSvg.vue?vue&type=script&lang=js"
export * from "./FeatureSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports